import type { PostDTO } from '@hitit/api';

export class PostManager {

	static readonly tempREG = /^\|TEMP\|/;
	static readonly newREG = /^\|NEW\|/;

	public postList: PostDTO[]
	public deletedItems: PostDTO[] = []

	constructor(postList: PostDTO[]) {
		this.postList = postList.sort((a, b) => new Date(b.createdDate || "").getTime() - new Date(a.createdDate || "").getTime())
	}

	addPost(postDTO: PostDTO) {
		postDTO.id = `|NEW|${Math.random()}`
		this.postList.unshift(postDTO)
	}

	updatePost(postDTO: PostDTO) {
		const index = this.postList.findIndex((v) => v.id === postDTO.id)
		const changedItem = Object.assign(this.postList[index], postDTO)
		this.postList[index] = changedItem
	}

	deletePost(id: string) {
		const filtered = this.postList.filter((v) => v.id !== id)
		const deletedPost = this.postList.filter((v) => v.id === id)
		this.postList = filtered
		if (PostManager.newREG.test(id)) {
			return
		}
		this.deletedItems.push(...deletedPost)
	}

	getItem(id: string) {
		const item = this.postList.find((v) => v.id === id) || null;
		return item
	}

	newItem(): PostDTO {
		return {
			id: `|TEMP|${Math.random()}`,
			displaySort: 0,
			createdDate: "",
			title: "",
			linkUrl: "",
			image: "",
			documentState: "DRAFT",
		}
	}

	getDTO_ToSend() {
		const newly = this.postList.filter((v) => PostManager.newREG.test(v.id || ""))
		const updated = this.postList.filter((v) => !(PostManager.newREG.test(v.id || "")))
		const deleted = this.deletedItems

		return {
			newly: newly.map((v) => Object.assign({}, v, { id: undefined, displaySort: undefined })),
			updated,
			deleted
		}
	}
}
